import React, { useEffect } from "react";
import { authenticateUser } from "commons/services";
import { useNavigate } from "react-router-dom";
import { Spinner } from "commons/components/spinner";
import { Flex } from "@sparrowengg/twigs-react";

const AuthenticateUser = () => {
  const navigate = useNavigate();

  useEffect(() => {
      authenticateUser();
      navigate("/");
  }, []);

  return (
    <Flex
      alignItems="center"
      justifyContent="center"
      css={{ width: "100%", height: "100vh" }}
    >
      <Spinner size="md" />
    </Flex>
  );
};

export default AuthenticateUser;
